import React, { useState, useEffect } from "react";
import { fetchWithAuth } from "../../../Auth/AuthFetch";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    saveSubscriptionPlansAPI, getSubscriptionPlansByVerticalAPI
} from "../../../Servicefile/GroceryService.jsx";
const API_KEY = "your_api_key_here";

const ALL_POSSIBLE_MODULES = [
    "Home", "Company", "Settings_Controls", "Account_History", "Order_Management",
    "Menu_Management", "Inventory_Management", "Payment_Transactions",
    "Promotions_Discounts", "Report_Analysis"
].sort();

const PLAN_DURATIONS = [90, 180, 365];

const Grocerysubscriptiondata = () => {
    const [planModuleConfig, setPlanModuleConfig] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingPlans, setEditingPlans] = useState({});
    const { showLoader, hideLoader } = useLoader();
    // Fetch plans
    useEffect(() => {

        const fetchAllPlanData =
            async () => {

                try {

                    showLoader();

                    setLoading(true);

                    const data =
                        await getSubscriptionPlansByVerticalAPI(
                            API_KEY
                        );

                    const config = {};

                    ["BASIC", "PREMIUM"].forEach(
                        (planType) => {

                            config[
                                planType
                            ] =
                                PLAN_DURATIONS.map(
                                    (days) => {

                                        const existing =
                                            data.find(
                                                (p) =>
                                                    p.planType ===
                                                    planType &&
                                                    p.days ===
                                                    days
                                            );

                                        return existing
                                            ? {
                                                ...existing,

                                                price:
                                                    existing.price ||
                                                    0,

                                                businessModules:
                                                    Array.isArray(
                                                        existing.businessModules
                                                    )
                                                        ? existing.businessModules
                                                        : [],
                                            }
                                            : {
                                                id: null,

                                                days,

                                                price: 0,

                                                planType,

                                                businessModules:
                                                    [],
                                            };
                                    }
                                );
                        }
                    );

                    setPlanModuleConfig(
                        config
                    );

                } catch (err) {

                    console.error(
                        "❌ Fetch plan data failed:",
                        err
                    );

                    setError(
                        err.message
                    );

                } finally {

                    setLoading(false);

                    hideLoader();
                }
            };

        fetchAllPlanData();

    }, []);


    // Handlers
    const handleDaysChange = (planType, index, newDays) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType][index] = { ...updated[planType][index], days: Number(newDays) };
            return updated;
        });
    };

    const handlePriceChange = (planType, days, newPrice) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType] = updated[planType].map(p =>
                p.days === days ? { ...p, price: Number(newPrice) } : p
            );
            return updated;
        });
    };

    const handleModuleChange = (planType, days, moduleName, isChecked) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType] = updated[planType].map(plan => {
                if (plan.days === days) {
                    const modules = plan.businessModules || [];
                    return {
                        ...plan,
                        businessModules: isChecked
                            ? [...new Set([...modules, moduleName])]
                            : modules.filter(m => m !== moduleName)
                    };
                }
                return plan;
            });
            return updated;
        });
    };

    const handleStartEdit = planType => {
        setEditingPlans(prev => ({ ...prev, [planType]: true }));
    };

    const handleStopEdit = planType => {
        setEditingPlans(prev => ({ ...prev, [planType]: false }));
    };

    const handleSavePlans =
        async (planType) => {

            try {

                const plans =
                    planModuleConfig[
                    planType
                    ] || [];

                const savedPlans =
                    await saveSubscriptionPlansAPI(
                        plans,
                        planType,
                        API_KEY
                    );

                // ✅ Update local state
                setPlanModuleConfig(
                    (prev) => {

                        const updated = {
                            ...prev,
                        };

                        updated[
                            planType
                        ] =
                            updated[
                                planType
                            ].map((p) => {

                                const saved =
                                    savedPlans.find(
                                        (sp) =>
                                            sp.days ===
                                            p.days
                                    );

                                return saved
                                    ? saved
                                    : p;
                            });

                        return updated;
                    }
                );

                handleStopEdit(
                    planType
                );

                alert(
                    "All plans saved successfully!"
                );

            } catch (err) {

                console.error(
                    err
                );

                alert(
                    `Error saving plans: ${err.message}`
                );
            }
        };





    if (loading)
        return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
    if (error)
        return <div className="d-flex justify-content-center align-items-center vh-100 text-danger">Error: {error}</div>;

    return (
        <div className="container-fluid" style={{ paddingTop: "140px", paddingBottom: "20px", height: "500px" }}>
            <div className="row justify-content-center">
                <div className="col-lg-2"></div>
                <div className="col-lg-8">
                    {["BASIC", "PREMIUM"].map(planType => {
                        const plans = planModuleConfig[planType] || [];
                        const isEditing = editingPlans[planType];

                        // Filter modules for BASIC plan
                        const filteredModules = planType === "BASIC"
                            ? ALL_POSSIBLE_MODULES.filter(
                                m => !["Table_Management", "Chef_Management", "Inventory_Management", "Delivery_Management"].includes(m)
                            )
                            : ALL_POSSIBLE_MODULES;

                        return (
                            <div className="col-lg-12 mb-5" key={planType}>
                                <h4 className="mb-3 text-center">{planType} PLAN</h4>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
                                                <th style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>Modules / Days</th>
                                                {plans.map((plan, index) => (
                                                    <th key={index} style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
                                                        <input
                                                            type="number"
                                                            value={plan.days}
                                                            onChange={e => handleDaysChange(planType, index, e.target.value)}
                                                            style={{ width: "80px", textAlign: "center" }}
                                                            readOnly={!isEditing}
                                                        />
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td><strong>Price (₹)</strong></td>
                                                {plans.map(plan => (
                                                    <td key={plan.days}>
                                                        <input
                                                            type="number"
                                                            value={plan.price}
                                                            onChange={e =>
                                                                handlePriceChange(planType, plan.days, e.target.value)
                                                            }
                                                            style={{ width: "100px", textAlign: "center" }}
                                                            readOnly={!isEditing}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>

                                            {filteredModules.map(moduleName => (
                                                <tr key={moduleName}>
                                                    <td className="text-start">{moduleName.replace(/_/g, " ")}</td>
                                                    {plans.map(plan => (
                                                        <td key={`${plan.days}-${moduleName}`}>
                                                            <input
                                                                type="checkbox"
                                                                checked={plan.businessModules.includes(moduleName)}
                                                                onChange={e =>
                                                                    handleModuleChange(planType, plan.days, moduleName, e.target.checked)
                                                                }
                                                                disabled={!isEditing}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}

                                            <tr>
                                                <td colSpan={plans.length + 1} className="text-center">
                                                    {isEditing ? (
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => handleSavePlans(planType)}
                                                        >
                                                            Save Plans
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-warning"
                                                            onClick={() => handleStartEdit(planType)}
                                                        >
                                                            Update Plans
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })}

                </div>
                <div className="col-lg-2"></div>
            </div>
        </div>
    );
};

export default Grocerysubscriptiondata;
